import styles from './style.module.css'
import FooterStart from "../../../components/Common/StartFooter";
import Frame from "./Frame.jpg";
import student from "../../../assets/images/illustrations/assessmen-table.png";
import { useNavigate } from "react-router-dom";
import { useContext } from 'react';
import mainContext from '../../../context/mainContext';
import { useEffect } from 'react';
import dataContext from '../../../context/dataContext';
import UmooveApi from '../../../components/api/UmooveApi';
// import data from './data'

// Creator : Team A - Daniel
export default function AssessmentStart() {
    const navigate = useNavigate()
    const { initCam: { alreadiInit, setAlreadyInit } } = useContext(mainContext)
    function checkCameraPermission() {
        window.permissions.checkPermission(window.permissions.CAMERA, function (status) {
            if (!status.hasPermission) {
                requestCameraPermission();
            } else {
                // navigate('/assessments/camera-face', { state: "from-start" }/* , { state: { data: data } } */)
                setTimeout(() => {

                    navigate('/assessments/camera-face'/* , { state: { data: data } } */)
                }, 700)
            }
        });
    }

    function requestCameraPermission() {
        window.permissions.requestPermission(window.permissions.CAMERA, function (status) {
            if (!status.hasPermission) {
                console.error('Camera permission not granted');
                alert("To ensure optimal functionality of the application, this permission is necessary.")
            } else {
                UmooveApi.API_stopUmoove().then(() => {
                    setAlreadyInit(false)//so wיen you go forword in pages, the camera will init
                    setTimeout(() => {

                        navigate('/assessments/camera-face'/* , { state: { data: data } } */)
                    }, 700)
                })
            }
        }, function () {
            console.error('Camera permission request denied');
        });
    }
    const startFunction = () => { window.cordovaOn ? checkCameraPermission() : navigate('/assessments/camera-face', { state: "from-start" }/* , { state: { data: data } } */) }

    const { header: { setPageName } } = useContext(mainContext)
    const { userDetails, assessmentId, serverData, setExamData } = useContext(dataContext);

    useEffect(() => {
        setPageName("Weekly Measure")
        if (assessmentId.title) {

            setExamData(assessmentId)
        } else {
            navigate('/')
        }
        return () => setPageName("")
    }, [])

    return (
        <div className={styles.container}>
            <img src={student} alt="student" />
            <FooterStart
                startFunction={startFunction}
                title='START'
                explanation="While you are sitting comfortably, firmly rest your hand holding the smartphone, (see image) and press 'Start'."
                img={Frame}
            />
        </div>
    );
}


